import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import * as Yup from "yup";
import { Formik } from "formik";

import {
  Alert as MuiAlert,
  Button,
  TextField as MuiTextField,
} from "@mui/material";
import { spacing } from "@mui/system";

import useAuth from "../../hooks/useAuth";
// import { signUp } from "../../api/auth";

const Alert = styled(MuiAlert)(spacing);

const TextField = styled(MuiTextField)(spacing);

function SignUp() {
  const navigate = useNavigate();
  const { signUp } = useAuth();

  return (
    <Formik
      initialValues={{
        name: "",
        essNumber: "",
        email: "",
        password: "",
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        name: Yup.string().max(255).required("First name is required"),

        essNumber: Yup.string().max(255).required("Ess Number is required"),

        email: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("Email is required"),

        password: Yup.string()
          .min(6, "Must be at least 6 characters")
          .max(255)
          .required("Required"),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          const data = {
            email: values.email,
            essNumber: values.essNumber,
            name: values.name,
            password: values.password,
          };
          signUp(data)
            .then((res) => {
              console.log(res);
            })
            .catch((error) => console.log(error.response.data.message));
          navigate("/");
        } catch (error) {
          const message = error.message || "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          {errors.submit && (
            <Alert mt={2} mb={1} severity="warning">
              {errors.submit}
            </Alert>
          )}
          <TextField
            type="text"
            name="name"
            label="Name"
            value={values.name}
            error={Boolean(touched.name && errors.name)}
            fullWidth
            helperText={touched.name && errors.name}
            onBlur={handleBlur}
            onChange={handleChange}
            my={3}
          />

          <TextField
            type="text"
            name="essNumber"
            label="Ess Number"
            value={values.essNumber}
            error={Boolean(touched.essNumber && errors.essNumber)}
            fullWidth
            helperText={touched.essNumber && errors.essNumber}
            onBlur={handleBlur}
            onChange={handleChange}
            my={3}
          />

          <TextField
            type="email"
            name="email"
            label="Email address"
            value={values.email}
            error={Boolean(touched.email && errors.email)}
            fullWidth
            helperText={touched.email && errors.email}
            onBlur={handleBlur}
            onChange={handleChange}
            my={3}
          />

          <TextField
            type="password"
            name="password"
            label="Password"
            value={values.password}
            error={Boolean(touched.password && errors.password)}
            fullWidth
            helperText={touched.password && errors.password}
            onBlur={handleBlur}
            onChange={handleChange}
            my={3}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={isSubmitting}
          >
            Sign up
          </Button>
        </form>
      )}
    </Formik>
  );
}

export default SignUp;
